import { createApp } from 'vue'
import HoursCalculator from './HoursCalculator.vue'
import './assets/global.css'

createApp(HoursCalculator).mount('#hours')
